import { v4 as uuid } from 'uuid';
/**
 * 安全 JSON.parse
 *
 * @param {string} text 需要 JSON.parse 的字符串
 * @returns {object} JSON.parse 返回的值
 */
export const safeJSONParse = (text, defaultValue = {}) => {
    try {
        return JSON.parse(text);
    }
    catch (error) {
        return defaultValue;
    }
};
/**
 * delay
 *
 * @param {number} time 需要delay的时间，ms
 * @returns {Promise} delay的promise
 */
export const sleep = (time = 0) => new Promise((resolve) => setTimeout(resolve, time));
export { uuid };
